// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderX":"TableHeader_tableHeaderX__2csje"};